// export {FetchPicklistDropdown}
import api from "./Api";
import { PORTS } from "../config/modulePort";
import axios from "axios";

interface PicklistItemPayload {
  pickListGroupId: string; // ID of the picklist group
  itemName: string; // Name of the picklist item
  displayName: string; // Display name for the picklist item
  description?: string; // Optional description
  comments?: string; // Optional comments
  sortSequence: number; // Sort order of the item
  isActive: boolean; // Active status of the item
  loggedInUserId: number; // ID of the logged-in user making the request
}
const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || ""; // Default to an empty string or another default value

const picklistAPI = api(PICKLIST_URL);
///////////////// Fetch Picklist Groups////////////////////////////////
export const FetchPicklistGroups = async (): Promise<any> => {
  try {
    const response = await picklistAPI.get(`/api/picklist/groups`);
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching picklist groups:", error);
    throw new Error("Unable to fetch picklist groups. Please try again later.");
  }
};

/////////////////////////////// picklist group detains//////////////////////////
export const FetchPicklistGroupDetails = async (
  groupId: string
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `api/picklist/group/details?pickListGroupId=${groupId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching picklist items:", error);
    throw new Error("Unable to fetch picklist items. Please try again later.");
  }
};

////////////////// Fetch Picklist Items by Group ID///////////////////////////////
export const FetchPicklistItems = async (
  groupId: number,
  sortBy: string = "sortSequence",
  sortOrder: string = "asc"
): Promise<any> => {
  try {
    console.log(picklistAPI, "picklistAPI");

    const response = await picklistAPI.post(`/api/picklist/items/bygroupid`, {
      pickListGroupId: groupId,
      sortBy,
      sortOrder,
    });
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching picklist items:", error);
    throw new Error("Unable to fetch picklist items. Please try again later.");
  }
};

// Update Picklist Group
export const UpdatePicklistGroup = async (
  groupId: string,
  itemdescription?: string,
  comment?: string,
  userId?: number
): Promise<any> => {
  try {
    const response = await picklistAPI.put(`/api/picklist/group/update`, {
      pickListGroupId: groupId,
      groupDescription: itemdescription,
      comments: comment,
      loggedInUserId: userId,
    });
    return response.data;
  } catch (error) {
    console.error(" updating picklist group:", error);
    throw new Error("Unable to update picklist group. Please try again later.");
  }
};
/////////////////// Add Picklist Item /////////////////////////////////
// Add Picklist Item
export const AddPicklistItem = async (data: any): Promise<any> => {
  try {
    const response = await picklistAPI.post("/api/picklist/item/add", data);
    return response.data;
  } catch (error) {
    console.error("Error adding picklist item:", error);
    throw new Error("Unable to add picklist item. Please try again later.");
  }
};

// Update Picklist Item
export const UpdatePicklistItem = async (data: any): Promise<any> => {
  try {
    const response = await picklistAPI.put(`/api/picklist/item/update`, data);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating picklist item:",
      error?.response?.data || error.message
    );
    throw new Error(
      error?.response?.data?.message ||
        "Unable to update picklist item. Please try again later."
    );
  }
};
export const SortPicklistItem = async (data: any): Promise<any> => {
  try {
    const response = await picklistAPI.post(
      `/api/picklist/items/bygroupid`,
      data
    );
    console.log(response.data, "responseresponse");
    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating picklist item:",
      error?.response?.data || error.message
    );
    throw new Error(
      error?.response?.data?.message ||
        "Unable to update picklist item. Please try again later."
    );
  }
};
